import {useStyles} from '../../hooks/styles';

const GetStyles = () =>
  useStyles((theme) => {
    return {
      goToAppContainer: {
        backgroundColor: '#E5E5E5',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'row',
        height: 48,
      },
      item: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
      },
      infoBlock: {display: 'flex', flexDirection: 'row'},
      textContainer: {
        display: 'flex',
        marginLeft: 8,
        marginTop: 10,
        flexDirection: 'column',
        alignItems: 'flex-start',
        height: '100%',
        justifyContent: 'center',
      },
      header: {
        ...theme.theme.fonts.label,
      },
      text: {
        ...theme.theme.fonts.small,
      },
      goToAppButton: {
        backgroundColor: theme.theme.button.primary.backgroundColor,
        height: 28,
        width: 100,
      },
      link: {
        height: 28,
        width: 100,
        borderRadius: 4,
        backgroundColor: theme.theme.button.primary.backgroundColor,
        alignItems: 'center',
        justifyContent: 'center',
        ...theme.theme.fonts.h6Light,
      },
      linkText: {
        color: '#ffffff',
      },
    };
  });

export type Styles = ReturnType<typeof GetStyles>;

export default GetStyles;
